export default __webpack_public_path__ + "static/media/AccessoriesSim.550553b9.png";